// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `span.cesium-projectionPicker-wrapper {
  display: inline-block;
  position: relative;
  margin: 0 3px;
}

.cesium-projectionPicker-visible {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.25s linear;
}

.cesium-projectionPicker-hidden {
  visibility: hidden;
  opacity: 0;
  transition:
    visibility 0s 0.25s,
    opacity 0.25s linear;
}

.cesium-projectionPicker-wrapper .cesium-projectionPicker-none {
  display: none;
}

.cesium-projectionPicker-wrapper .cesium-projectionPicker-dropDown-icon {
  box-sizing: border-box;
  padding: 0;
  margin: 3px 0;
}

.cesium-projectionPicker-wrapper .cesium-projectionPicker-buttonPerspective,
.cesium-projectionPicker-wrapper .cesium-projectionPicker-buttonOrthographic {
  margin: 0 0 3px 0;
}

.cesium-projectionPicker-wrapper
  .cesium-projectionPicker-buttonPerspective
  .cesium-projectionPicker-iconOrthographic {
  left: 100%;
}

.cesium-projectionPicker-wrapper
  .cesium-projectionPicker-buttonOrthographic
  .cesium-projectionPicker-iconPerspective {
  left: -100%;
}

.cesium-projectionPicker-wrapper .cesium-projectionPicker-selected {
  border-color: #2e2;
  box-shadow:
    0 0 8px #fff,
    0 0 8px #fff;
}
`, "",{"version":3,"sources":["webpack://./cesium/Source/Widgets/ProjectionPicker/ProjectionPicker.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV;;wBAEsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,aAAa;AACf;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB;;gBAEc;AAChB","sourcesContent":["span.cesium-projectionPicker-wrapper {\n  display: inline-block;\n  position: relative;\n  margin: 0 3px;\n}\n\n.cesium-projectionPicker-visible {\n  visibility: visible;\n  opacity: 1;\n  transition: opacity 0.25s linear;\n}\n\n.cesium-projectionPicker-hidden {\n  visibility: hidden;\n  opacity: 0;\n  transition:\n    visibility 0s 0.25s,\n    opacity 0.25s linear;\n}\n\n.cesium-projectionPicker-wrapper .cesium-projectionPicker-none {\n  display: none;\n}\n\n.cesium-projectionPicker-wrapper .cesium-projectionPicker-dropDown-icon {\n  box-sizing: border-box;\n  padding: 0;\n  margin: 3px 0;\n}\n\n.cesium-projectionPicker-wrapper .cesium-projectionPicker-buttonPerspective,\n.cesium-projectionPicker-wrapper .cesium-projectionPicker-buttonOrthographic {\n  margin: 0 0 3px 0;\n}\n\n.cesium-projectionPicker-wrapper\n  .cesium-projectionPicker-buttonPerspective\n  .cesium-projectionPicker-iconOrthographic {\n  left: 100%;\n}\n\n.cesium-projectionPicker-wrapper\n  .cesium-projectionPicker-buttonOrthographic\n  .cesium-projectionPicker-iconPerspective {\n  left: -100%;\n}\n\n.cesium-projectionPicker-wrapper .cesium-projectionPicker-selected {\n  border-color: #2e2;\n  box-shadow:\n    0 0 8px #fff,\n    0 0 8px #fff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
